<template>
  <div class="tekenaarsheader">
    <div class="headerleft">
      <div class="ico">
        <img src="../../../assets/sidebar/opdrachten-ico.svg" alt />
      </div>
      <h2 class="header">Opdrachten</h2>
      <SearchfieldWithReset :filterOn="opdrFilters.bedrijfsnaam" filterBy="bedrijfsnaam" />
    </div>

    <button @click="$emit('showVoegOpdrachtToeModal')">+ Voeg opdracht toe</button>
  </div>
</template>

<script>
import store from "@/store"
import SearchfieldWithReset from "./SearchfieldWithReset2"

export default {
  name: "TekenaarsHeader",
  components: {
    SearchfieldWithReset
  },
  computed: {
    showOpdrFilters: {
      get() {
        return store.state.showOpdrFilters
      },
      set(e) {
        store.commit("toggleShowOpdrFilters", e)
      }
    },
    tekFilters() {
      return store.state.tekFilters
    },
    opdrFilters() {
      return store.state.opdrFilters
    }
  },
  methods: {
    fixupdate(e) {
      store.state.tekFilters.name = e
    }
  }
}
</script>

<style scoped>
.header {
  color: #0b1125;
  opacity: 0.8;
  font-weight: 600;
  padding-right: 30px;
  font-size: 26px;
}
.headerleft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ico {
  background-color: #ff9326;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  padding: 4px;
  margin-right: 10px;
}

.tekenaarsheader {
  z-index: 3;
  /* background-color: #FAFCFE; */
  background-color: #eff2f5;
  /* position: fixed; */
  display: flex;
  width: 100%;
  /* height: 70px; */
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  /* border-bottom: 1px solid #E7E7F3; */
}

.searchbarholder {
  position: relative;
}
.reset-btn {
  position: absolute;
  width: 24px;
  height: 24px;
  top: 8px;
  right: 10px;
  cursor: pointer;
}
.searchfield {
  width: 200px;
  height: 40px;
  background-color: #e4ecfa;
  border-radius: 100px;
  border: none;
  font-size: 14px;
  padding: 10px 10px 10px 14px;
}
.active {
  background-color: #3076ea;
  color: white;
}

button {
  color: #0475f2;
  border: 1px solid #0475f2;
  border-radius: 5px;
  padding: 8px 11px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  background-color: #eff2f5;
  margin-right: 100px;
}
button:hover {
  color: #fff;
  background-color: #0475f2;
}
button:active {
  color: #fff;
  background-color: #1b4d8d;
}
</style>
